<template>
  <div class="base">
    <div>
      <label>委托人员：</label><span>{{ row.orderLinkman }}</span>
    </div>
    <div>
      <label>委托单位：</label><span>{{ row.orderCompany }}</span>
    </div>
    <div>
      <label>服务名称：</label><span>{{ row.checkmallWaresName }}</span>
    </div>
    <div>
      <label>委托金额：</label
      ><span class="base-price">￥{{ row.orderPrice }}元</span>
    </div>
    <div>
      <label>支付状态：</label>
      <span
        class="base-status"
        :class="{ pay: row.orderPayStatus === ORDER_PAY_STATUS.offlinePaid }"
        >{{ orderPayStatusMap[row.orderPayStatus] }}</span
      >
    </div>
    <div>
      <label>下单时间：</label><span>{{ row.createTime }}</span>
    </div>
    <div v-if="row.saleStatus">
      <label>退款审核状态：</label>
      <span class="base-refund">{{ REFUND_STATUS_TEXT[row.saleStatus] }}</span>
    </div>
  </div>
</template>
<script>
import { PAYSTATUS_SUCCESS, ORDER_PAY_STATUS } from "@/constant/index";
import { REFUND_STATUS_TEXT, ORDER_PAYSTATUS } from "@/constant/dict";
export default {
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      PAYSTATUS_SUCCESS,
      REFUND_STATUS_TEXT,
      ORDER_PAY_STATUS,
      orderPayStatusMap: {},
    };
  },
  created() {
    this.getDict();
  },
  methods: {
    // 获取字典数据
    async getDict() {
      const data = await this.$store.dispatch("getDictData", ORDER_PAYSTATUS);
      const payStatusMap = {};
      data.forEach((item) => {
        payStatusMap[item.dictValue] = item.dictLabel;
      });
      this.orderPayStatusMap = payStatusMap;
    },
  },
};
</script>
<style lang="scss" scoped>
.base {
  padding: 10px;
  &-status {
    color: #f56c6c;
    &.pay {
      color: #67c23a;
    }
  }
  > div {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0px;
    }
    > label {
      color: #909399;
    }
  }
  &-price,
  &-refund {
    color: #f56c6c;
  }
}
</style>
